var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4968001e-5358-49e9-af8f-7d35133b2e04",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "558bc371-d86e-47eb-b44f-770ba5d4d8b4",
    "data-name": "Cloud_upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "065c0da4-91b9-4324-b1f2-5712ac393ad5",
    "data-name": "Cloud_download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a5f70ef4-c883-4f3a-a3c8-5920a92f6332",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "7bc71e71-c1c2-4883-a80f-08fb219dc34b",
    "data-name": "<Path>",
    d: "M118.35,124s22.44.86,31.19-3a38.27,38.27,0,0,0,22.28-31c1.31-13.09-4.66-27.47-15.94-34.43-5.61-3.45-12.16-4.85-18.71-5.42a78.3,78.3,0,0,0-11.19.5,44.1,44.1,0,0,0-4.26-9.48,43.66,43.66,0,0,0-33.66-21,42.61,42.61,0,0,0-35.72,15.1,44,44,0,0,0-8.91,17.46c-.43,1.7-1.28,6.44-1.28,6.44A33.46,33.46,0,0,0,30.28,65.9C19.77,75.3,17.21,91.36,23.09,104c5.34,11.48,16.81,20,29.57,20h21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 152,
    x2: 96,
    y2: 68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "70 96 96 68 122 96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b15511b6888ca54e7e626986a3c96c46.svg";
export { ForwardRef as ReactComponent };